import * as CONSTANTS from './constants';
import { lockBody, unlockBody } from './lock-body';

export class MobileNav {
    constructor() {
        const mobileNavTrigger = document.querySelector('.mobile-nav-trigger-js');
        const mobileSearchTrigger = document.querySelector('.mobile-nav-search-trigger-js');
        const body = CONSTANTS.GLOBAL_BODY;

        function closeMobileMenu() {
            mobileNavTrigger.classList.remove('mobile-nav-trigger-open');
            body.classList.remove('mobile-nav-open');
            unlockBody();
        }

        function closeMobileSearch() {
            if (mobileSearchTrigger != null) {
                mobileSearchTrigger.classList.remove('mobile-nav-search-trigger-open');
            }
            body.classList.remove('mobile-nav-search-open');
        }

        mobileNavTrigger.addEventListener('click', () => {
            if (mobileSearchTrigger != null && mobileSearchTrigger.classList.contains('mobile-nav-search-trigger-open')) {
                closeMobileSearch();
            }

            if (mobileNavTrigger.classList.contains('mobile-nav-trigger-open')) {
                closeMobileMenu();
            } else {
                mobileNavTrigger.classList.add('mobile-nav-trigger-open');
                body.classList.add('mobile-nav-open');
                lockBody();
            }
        });

        if (mobileSearchTrigger != null) {
            mobileSearchTrigger.addEventListener('click', () => {
                if (mobileNavTrigger.classList.contains('mobile-nav-trigger-open')) {
                    closeMobileMenu();
                }

                if (mobileSearchTrigger.classList.contains('mobile-nav-search-trigger-open')) {
                    closeMobileSearch();
                } else {
                    mobileSearchTrigger.classList.add('mobile-nav-search-trigger-open');
                    body.classList.add('mobile-nav-search-open');
                    document.getElementById('headerSearchField').focus();
                }
            });
        }

        const mobileBreakpoint = `${CONSTANTS.MOBILE_BREAKPOINT + 0.1}rem`;

        window.addEventListener('resize', () =>
            window.requestAnimationFrame(() => {
                if (window.matchMedia(`(min-width:${mobileBreakpoint})`).matches) {
                    if (body.classList.contains('mobile-nav-open')) {
                        closeMobileMenu();
                    } else if (body.classList.contains('mobile-nav-search-open')) {
                        closeMobileSearch();
                    }
                }
            })
        );
    }
}
